import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';

import { serviceActions } from 'state/modules/service';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getIn from '../../components/connectedForm/utils/getIn';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Remittance',
    documentNamePlural: 'Remittances',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    props.generationMutation,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Remittances',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

function alertError(title, message, type, dispatch) {
  dispatch(serviceActions.genericAlert(title, message, type));
}

function getMutationProps(state, props, defaultMutationProps) {
  //Sanitize the sales order - This is because we have the mutated version from salesOrderUpdate.
  let entityValue = normalizeVariables(getIn(props, 'values'));
  if (entityValue.entityMetaData) delete entityValue.entityMetaData;
  defaultMutationProps[props.mutationKey] = entityValue;
  return defaultMutationProps;
}
